export class PushNotificationTranslator {
  /**
   * 登録処理用ペイロード作成
   * @param {*} item 登録画面入力情報
   * @param {*} attachFiles 添付ファイル情報
   * @param {*} translationsInfo 翻訳言語情報
   */
  static toCreatePayload(item, attachFiles, translationsInfo) {
    let retPayload = {
      disaster_no: item.disasterNo, // 災害番号
      emerg_cls: item.emergCls, // 緊急事態区分
      delivery_ca: "PU", // 配信先キャリア（"PU"固定）
      delivery_lev: item.deliveryLevel, // 配信レベル
      disaster_cls: item.disasterCls, // 災害区分
      delivery_status: item.deliveryStatus, // 配信ステータス
      delivery_title: item.deliveryTitle[0], // 配信タイトル
      delivery_body: item.deliveryBody[0], // 配信内容
      is_post_line: item.isPostLine ? "1" : "0", // LINE連携有無
      is_confirm_having_iodine: item.isConfirmHavingIodine ? "1" : "0", // 安定ヨウ素剤確認有無
      is_post_twitter: item.isPostTwitter ? "1" : "0", // Twitter連携有無
      translation_status_en: item.translationStatusEn, // 翻訳ステータス(英語)
      translation_status_ko: item.translationStatusKo, // 翻訳ステータス(韓国語)
      translation_status_zh_cn: item.translationStatusZhCn, // 翻訳ステータス(中簡体)
      translation_status_zh_tw: item.translationStatusZhTw, // 翻訳ステータス(中繫体)
      attach_files: attachFiles, // 添付ファイル情報
      translations: translationsInfo, // 翻訳言語情報
      dests: item.dests // 配信先エリア
    };
    return retPayload;
  }

  /**
   * 編集処理用ペイロード作成
   * @param {*} item 編集画面入力情報
   * @param {*} attachFiles 添付ファイル情報
   * @param {*} detachFiles 削除ファイル情報
   * @param {*} translationsInfo 翻訳言語情報
   */
  static toUpdatePayload(item, attachFiles, detachFiles, translationsInfo) {
    return {
      delivery_no: item.deliveryNo, // 配信番号
      disaster_no: item.disasterNo, // 災害番号
      emerg_cls: item.emergCls, // 緊急事態区分
      hash: item.hash, // ハッシュ値
      delivery_lev: item.deliveryLevel, // 配信レベル
      disaster_cls: item.disasterCls, // 災害区分
      delivery_status: item.deliveryStatus, // 配信ステータス
      delivery_title: item.deliveryTitle[0], // 配信タイトル
      delivery_body: item.deliveryBody[0], // 配信内容
      is_post_line: item.isPostLine ? "1" : "0", // LINE連携有無
      is_confirm_having_iodine: item.isConfirmHavingIodine ? "1" : "0", // 安定ヨウ素剤確認有無
      is_post_twitter: item.isPostTwitter ? "1" : "0", // Twitter連携有無
      translation_status_en: item.translationStatusEn, // 翻訳ステータス(英語)
      translation_status_ko: item.translationStatusKo, // 翻訳ステータス(韓国語)
      translation_status_zh_cn: item.translationStatusZhCn, // 翻訳ステータス(中簡体)
      translation_status_zh_tw: item.translationStatusZhTw, // 翻訳ステータス(中繫体)
      attach_files: attachFiles, // 添付ファイル情報
      detach_files: detachFiles, // 削除ファイル情報
      translations: translationsInfo, // 翻訳言語情報
      dests: item.dests // 配信先エリア
    };
  }

  /**
   * 削除用ペイロード作成
   * @param {*} item 削除対象レコード情報
   */
  static toDeletePayload(item) {
    return {
      delivery_no: item.delivery_no, // 配信番号
      hash: item.hash // ハッシュ値
    };
  }

  /**
   * 翻訳用ペイロード作成
   * @param {*} item 翻訳対象レコード情報
   * @param {*} translationsInfo 翻訳言語情報
   */
  static toTranslationPayload(item, translationsInfo) {
    return {
      delivery_no: item.deliveryNo, // 配信番号
      hash: item.hash, // ハッシュ値
      translations: translationsInfo // 翻訳言語情報
    };
  }

  /**
   * 再送信用ペイロード作成
   * @param {*} item 再送信対象レコード情報
   */
  static toResendPayload(item) {
    return {
      delivery_no: item.delivery_no, // 配信番号
      hash: item.hash // ハッシュ値
    };
  }
}
